define('SC.SizeChart.1.0.0.SizeChart', [
    'ProductDetails.Full.View',

    'SizeChart.Router',

    'ItemSizeChartLink.View',
    'SizeChart.CCT.LinkView',

    'SizeChart.Model'
], function SizeChart(
    ProductDetailsFullView,

    Router,

    ItemSizeChartLinkView,
    CCTSizeChartLinkView,

    Model
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var sizeChartModel = new Model();
            var pdp = application.getComponent('PDP');

            application.getComponent('CMS').registerCustomContentType({
                id: 'sizechart',
                view: CCTSizeChartLinkView
            });

            pdp.on('afterShowContent', function afterShowContent() {
                var internalid = pdp.getItemInfo().item.custitem_ef_sc_size_chart_id;
                if (internalid) {
                    sizeChartModel.fetch({
                        data: {
                            internalid: internalid
                        }
                    });
                }
            });

            pdp.addChildViews(
                pdp.PDP_FULL_VIEW, {
                    'Product.Sku': {
                        'Item.SizeChart': {
                            childViewIndex: 4,
                            childViewConstructor: function childViewConstructor() {
                                return new ItemSizeChartLinkView({
                                    pdpItemInfo: pdp.getItemInfo(),
                                    sizeChartModel: sizeChartModel
                                });
                            }
                        }
                    }
                });

            return new Router(application);
        }
    };
});
